import {AfterViewInit, Component, OnInit} from '@angular/core';
import {SalesStoreListComponent} from '../sales-store-list.component';

@Component({
  selector: 'app-sales-store-list-v3',
  templateUrl: './sales-store-list-v3.component.html',
})
export class SalesStoreListComponentV3 extends SalesStoreListComponent implements OnInit, AfterViewInit {
  override ngOnInit(): void {
    // Inicializar formulario de filtros
    this.initForm();

    // Configurar búsqueda con debounce
    this.initSearchListener();

    // Cargar opciones de filtros
    this.initFilterOptions();

    // Cargar datos iniciales
    this.loadInitialData();
  }

  override ngAfterViewInit(): void {
    // Configurar observer para sticky header
    this.initStickyObserver();

    // Configurar observer para scroll infinito (con delay para que el DOM esté listo)
    setTimeout(() => this.initScrollObserver(), 1000);
  }
}